import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';

export default class extends Controller {
    connect() {
        if (Cookies.get('allow_cookies')) {
            this.hideBar();
        }

        if (this.cookiesAllowed()) {
            this.injectAnalytics();
        }
    }

    cookiesAllowed() {
        return Cookies.get('allow_cookies') === 'yes';
    }

    allow() {
        Cookies.set('allow_cookies', 'yes', { expires: 365 });
        this.injectAnalytics();
        this.hideBar();
    }

    reject() {
        Cookies.set('allow_cookies', 'no', { expires: 365 });
        this.hideBar();
    }

    hideBar() {
        this.element.classList.add('hidden');
    }

    injectAnalytics() {
        if (window.ym) {
            return;
        }

        try {
            // Загружаем скрипт
            (function(m, e, t, r, i, k, a) {
                m[i] = m[i] || function() {
                    (m[i].a = m[i].a || []).push(arguments)
                };
                m[i].l = 1 * new Date();

                k = e.createElement(t);
                a = e.getElementsByTagName(t)[0];
                k.async = 1;
                k.src = r;
                k.onload = function() {};
                k.onerror = function() {};
                a.parentNode.insertBefore(k, a);
            })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

            // Инициализируем счетчик
            window.ym(105825713, 'init', {
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true,
                ecommerce: "dataLayer"
            });

        } catch (error) {}
    }
}
